import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { CalendarIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -16
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" data-id="element-203">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-204">
        <img src="https://cdn.magicpatterns.com/uploads/jSutFGNNGFtY4eErA4fnFy/heylloyd-image-1773433429442.png" alt="Equipo de mudanzas profesional" className="w-full h-full object-cover" data-id="element-205" />
        <div className="absolute inset-0 bg-black/70" data-id="element-206" />
        <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/40 to-transparent" data-id="element-207" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 py-24 md:py-32" data-id="element-208">
        <motion.h1 className="text-gold text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 max-w-4xl" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-209">
          ¿Tu empresa de Moving compite por precio con 10 empresas más en cada
          llamada?
        </motion.h1>

        <motion.p className="text-light text-lg sm:text-xl md:text-2xl mb-10 max-w-3xl leading-relaxed" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: 'easeOut'
      }} data-id="element-210">
          Llenamos tu calendario de mudanzas con clientes que valoran la
          confianza y no con personas que eligen al más barato de Google.
        </motion.p>

        <motion.div className="w-full max-w-3xl mb-10 bg-black/40 backdrop-blur-sm p-5 sm:p-6 md:p-8 rounded-xl border border-white/10" variants={containerVariants} initial="hidden" animate="visible" data-id="element-211">
          <ul className="space-y-3 sm:space-y-4 text-left" data-id="element-212">
            <motion.li variants={itemVariants} className="flex items-start gap-3 sm:gap-4" data-id="element-213">
              <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500 shrink-0 mt-0.5" data-id="element-214" />
              <span className="text-light text-base sm:text-lg" data-id="element-215">
                Si el 80% de tus llamadas son de gente que pregunta el precio y
                luego desaparece
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 sm:gap-4" data-id="element-216">
              <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500 shrink-0 mt-0.5" data-id="element-217" />
              <span className="text-light text-base sm:text-lg" data-id="element-218">
                Si Yelp y los directorios te cobran por leads que nunca cierran
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 sm:gap-4" data-id="element-219">
              <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500 shrink-0 mt-0.5" data-id="element-220" />
              <span className="text-light text-base sm:text-lg" data-id="element-221">
                Si en temporada baja tu flota está parada sin trabajo
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 sm:gap-4" data-id="element-222">
              <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500 shrink-0 mt-0.5" data-id="element-223" />
              <span className="text-light text-base sm:text-lg" data-id="element-224">
                Si has tenido malas reseñas que dañan tu reputación online
                aunque seas una empresa seria
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 sm:gap-4" data-id="element-225">
              <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500 shrink-0 mt-0.5" data-id="element-226" />
              <span className="text-light text-base sm:text-lg" data-id="element-227">
                Si dependes de la temporada de verano para sobrevivir el año
              </span>
            </motion.li>
          </ul>
        </motion.div>

        <motion.div className="flex flex-col items-start w-full" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.9,
        ease: 'easeOut'
      }} data-id="element-228">
          <CTAButton className="w-full sm:w-auto" data-id="element-229">
            QUIERO MUDANZAS CONFIRMADAS
          </CTAButton>
          <p className="text-muted text-sm mt-4" data-id="element-230">
            Diagnóstico gratuito. Sin compromiso.
          </p>
          <div className="flex items-center gap-2 mt-3" data-id="element-231">
            <span className="text-muted text-sm" data-id="element-232">O agenda directamente:</span>
            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-gold text-sm font-semibold hover:underline inline-flex items-center gap-1.5" data-id="element-233">
              <CalendarIcon className="w-4 h-4" data-id="element-234" />
              Reservar en Google Calendar
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}